<template>
  <div
    class="flex flex-grow border-l-4 border-transparent p-0"
    :class="[
      show && checked
        ? 'activeRadioButton'
        : displayAsRequired && show
          ? 'border-red-100 bg-red-100 hover:border-light-gray hover:bg-off-white'
          : 'border-transparent hover:border-light-gray',
    ]"
  >
    <label
      class="container-radio group w-full"
      :class="{ 'text-dark-gray': show && checked }"
    >
      <slot />
      <div>
        <p
          class="text-1md"
          :class="{ 'text-dark-gray': checked, [customClass]: customClass }"
        >
          {{ item }}
        </p>
        <p
          v-if="!!subtext.length"
          class="text-xxs leading-3"
          :class="
            checked
              ? `text-dark-gray ${subtextClass}`
              : `text-body-color ${subtextClass}`
          "
          style="margin-top: 3px; margin-bottom: 3px"
          v-html="subtext"
        />
      </div>
      <input
        type="radio"
        :value="value"
        :name="name"
        :checked="show && checked"
        :disabled="disabled"
        @click="handleClick"
      />
      <span
        class="checkmark border-2 border-transparent"
        :class="[!(show && checked) ? 'group-hover:border-light-gray' : '']"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'RoundRadioButton',
  props: {
    item: String,
    name: String,
    checked: Boolean,
    subtext: {
      type: String,
      default: '',
    },
    customClass: {
      type: String,
      default: '',
    },
    subtextClass: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: true,
    },
    value: [String, Boolean, Number],
    handleClick: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    displayAsRequired: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.container-radio {
  @apply relative block flex h-full cursor-pointer items-center pl-12 text-left text-sm text-body-color;
  min-height: 60px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  @apply absolute left-2 h-6 w-6 rounded-full bg-light-gray;
  top: 30px;
  transform: translate(0, -50%);
}

/* When the checkbox is checked, add a yellow background */
.container-radio input:checked ~ .checkmark {
  @apply border-yellow-500 bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container-radio input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container-radio .checkmark:after {
  left: 0.375rem;
  top: 0.375rem;
  width: 0.5rem;
  height: 0.5rem;
  background-color: #000;
  border: solid #000;
  border-radius: 9999px;
}

.activeRadioButton {
  @apply border-yellow-500 bg-light-gray;
}
</style>
